<template>
  <div>
    <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header border-0 bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Help</h3>
                </div>
              </div>
              <br>
              <div class="row align-items-center">
                <div class="col">
                  <p class="mb-0">Welcome to the Potential help page coming soon!
                    <br>
                  For now, please email us at hello@findpotential.org</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/config/firebase.js";


export default {
  components: {
    
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
};
</script>
<style></style>
